"use strict";

/**
 * Clears the reactotron server.
 */
const clear = () => reactotron => {
  return {
    features: {
      clear: () => reactotron.send("clear")
    }
  };
};
export default clear;
//# sourceMappingURL=clear.js.map